import React from 'react';

function Pagination({ pagination, onPageChange, onPageSizeChange }) {
  if (!pagination) return null;

  const { page, pageSize, total, totalPages } = pagination;

  if (total <= pageSize) return null;

  const pages = [];
  const showPages = 5;
  let start = Math.max(1, page - Math.floor(showPages / 2));
  let end = Math.min(totalPages, start + showPages - 1);
  if (end - start + 1 < showPages) {
    start = Math.max(1, end - showPages + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px 0',
      borderTop: '1px solid #eee',
      marginTop: '12px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontSize: '13px', color: '#666' }}>
          共 {total} 条，每页
        </span>
        <select
          value={pageSize}
          onChange={(e) => onPageSizeChange && onPageSizeChange(parseInt(e.target.value))}
          style={{
            padding: '4px 8px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            fontSize: '13px'
          }}
        >
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
        <span style={{ fontSize: '13px', color: '#666' }}>条</span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <button
          onClick={() => onPageChange && onPageChange(1)}
          disabled={page === 1}
          style={{
            padding: '4px 8px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            background: page === 1 ? '#f5f5f5' : '#fff',
            color: page === 1 ? '#ccc' : '#333',
            cursor: page === 1 ? 'not-allowed' : 'pointer',
            fontSize: '12px'
          }}
        >
          首页
        </button>
        <button
          onClick={() => onPageChange && onPageChange(page - 1)}
          disabled={page === 1}
          style={{
            padding: '4px 8px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            background: page === 1 ? '#f5f5f5' : '#fff',
            color: page === 1 ? '#ccc' : '#333',
            cursor: page === 1 ? 'not-allowed' : 'pointer',
            fontSize: '12px'
          }}
        >
          上一页
        </button>

        {start > 1 && <span style={{ color: '#999' }}>...</span>}

        {pages.map(p => (
          <button
            key={p}
            onClick={() => onPageChange && onPageChange(p)}
            style={{
              minWidth: '28px',
              height: '28px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              background: p === page ? '#1890ff' : '#fff',
              color: p === page ? '#fff' : '#333',
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            {p}
          </button>
        ))}

        {end < totalPages && <span style={{ color: '#999' }}>...</span>}

        <button
          onClick={() => onPageChange && onPageChange(page + 1)}
          disabled={page === totalPages}
          style={{
            padding: '4px 8px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            background: page === totalPages ? '#f5f5f5' : '#fff',
            color: page === totalPages ? '#ccc' : '#333',
            cursor: page === totalPages ? 'not-allowed' : 'pointer',
            fontSize: '12px'
          }}
        >
          下一页
        </button>
        <button
          onClick={() => onPageChange && onPageChange(totalPages)}
          disabled={page === totalPages}
          style={{
            padding: '4px 8px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            background: page === totalPages ? '#f5f5f5' : '#fff',
            color: page === totalPages ? '#ccc' : '#333',
            cursor: page === totalPages ? 'not-allowed' : 'pointer',
            fontSize: '12px'
          }}
        >
          末页
        </button>

        <span style={{ fontSize: '13px', color: '#666', marginLeft: '8px' }}>
          {page}/{totalPages}
        </span>
      </div>
    </div>
  );
}

export default Pagination;